import { cva, } from 'class-variance-authority';

export { default as Card, } from './Card.vue';
export { default as CardHeader, } from './CardHeader.vue';
export { default as CardTitle, } from './CardTitle.vue';
export { default as CardDescription, } from './CardDescription.vue';
export { default as CardContent, } from './CardContent.vue';
export { default as CardFooter, } from './CardFooter.vue';

export const cardVariants = cva(
  'w-70 rounded shadow-sm hover:shadow-md',
  {
    variants: {
      intent: {
        courseCards: 'border bg-white border-gray-100',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
